import { render, staticRenderFns } from "./configuracionPuesto.vue?vue&type=template&id=54992abf&scoped=true"
import script from "./configuracionPuesto.vue?vue&type=script&lang=js"
export * from "./configuracionPuesto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54992abf",
  null
  
)

export default component.exports